import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatMatchType,
  formatMatchTypeStr,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export class MatchTypeColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    const title = i18n.getString('Details_View_Match_Type') || '__Match type__';

    super({
      name: 'matchType',
      property: 'Opportunities/MatchType',
      title,
      bodyClasses: ['grid-column-matchType'],
      colClasses: ['col-matchType'],
      helpId: 'Pop_BA_Recommendations_MatchType',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({ value }) {
    const { recommendationType } = this;
    return recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD ?
      formatMatchTypeStr(value, this.i18n) : formatMatchType(value, this.i18n);
  }

  get property() {
    return {
      get(item) {
        const matchType = 'SuggestedMatchType';
        return _.chain(item.Opportunities).first().result(matchType).value();
      },
      key: 'Opportunities/MatchType',
    };
  }

  get title() {
    const { i18n, recommendationType } = this;
    if (recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD) {
      return i18n.getString('Details_View_Match_Type_Suggested') || '__Suggested match type__';
    }
    return i18n.getString('Details_View_Match_Type') || '__Match type__';
  }
}
